import { Component, Host, h, Prop, State, Element } from '@stencil/core';
import { getCSSVal, getCSSVarValue, hexToRgb } from './../../../utils/utils';


@Component({
  tag: 'afs-accordian-wrapper',
  styleUrl: 'afs-accordian-wrapper.sass',
  shadow: true,
})
export class AfsAccordianWrapper {

  content! : HTMLElement;
  buttonWrapper! : HTMLElement;
  accordianContent! : HTMLElement;

  @Prop({ mutable: true }) gradientColor : string = "#FF0000";
  @Prop() color : string = "#000000";
  @Prop() textAlign : 'center' | 'left' | 'right' = 'center';
  @Prop() moreText : string = "LEARN MORE";
  @Prop() hideText : string = "HIDE";
  @State() isShown : boolean = false;
  @Element() host : HTMLElement;

  componentWillLoad() {
    if (this.gradientColor.includes('var(')) {
        this.gradientColor = getCSSVarValue(this.gradientColor);
    }
  }

  componentDidLoad() {
    if (!this.host.parentElement.id) {
      console.warn('Ensure that AFS-ACCORDIAN-WRAPPER is the child of an AFS-SECTION and that the parent AFS-SECTION must have an ID.')
    }

    const connectedButton = document.querySelector(`#${this.host.parentElement.id} afs-button[href="#${this.host.parentElement.id}"]`);
    if (!connectedButton){
      console.warn(`There is no AFS-BUTTON with the href of '#${this.host.parentElement.id}' in the document`)
      return;
    }
    
    connectedButton.textContent = this.moreText;
    connectedButton.addEventListener('click', () => {
      this.isShown = !this.isShown;
      connectedButton.textContent = this.isShown ? this.hideText : this.moreText;
      
      if (this.isShown) {
        this.accordianContent.style.height = getCSSVal(this.content, 'height');
        setTimeout(() => this.accordianContent.style.height = 'auto', 800);
      } else {
        this.accordianContent.style.height = getCSSVal(this.content, 'height');
        setTimeout(() => this.accordianContent.style.height = '160px', 10);
      }
      
    })
  }

  render() {
    const gradientRGB = hexToRgb(this.gradientColor);

    return (
      <Host>
        <div 
            class="accordian-content"
            style={{
              height: '160px',
            }}
            ref={el => this.accordianContent = el as HTMLElement}
          >
            <div class="content" ref={el => this.content = el as HTMLElement} style={{textAlign:this.textAlign, color: this.color}}>
              <slot></slot>
            </div>
            <div 
              class="gradient-overlay"
              style={{
                height: this.isShown ? '0rem' : '4rem',
                background: `linear-gradient(0deg, rgba(${gradientRGB.r},${gradientRGB.g},${gradientRGB.b},1) 0%, rgba(${gradientRGB.r},${gradientRGB.g},${gradientRGB.b},0) 100%)`,
              }}
            ></div>
          </div>
          <br/>
          <div class="button-wrapper" ref={el => this.buttonWrapper = el as HTMLElement}>
          </div>
      </Host>
    );
  }

}
